module.exports = "query UsersByNameQuery($terms:String!){users(search:$terms){edges{node{id username firstName lastName rowId customer{id name}}}}}"